class TimeoutError extends Error {
    constructor() {
        super('Timeout');
        this.name = 'TimeoutError';
    }
}

export async function getDelayedPromise<T>(value: T, delayTime: number) {
    await new Promise((resolve) => {
        setTimeout(resolve, delayTime);
    });

    return value;
}

export async function callPromiseWithTimeout<T>(promise: Promise<T>, timeoutTime: number): Promise<T> {
    let timeoutId;

    try {
        const result = await Promise.race<T>([
            promise,
            new Promise<T>((_, reject) => {
                timeoutId = setTimeout(() => {
                    reject(new TimeoutError());
                }, timeoutTime);
            }),
        ]);

        return result;
    } finally {
        clearTimeout(timeoutId);
    }
}
